<template>
  <v-container fluid>
    <PublicDocumentModal />
    <v-row>
      <template v-if="documents.length > 0">
        <v-col cols="12" v-for="document in documents" :key="document.id">
          <v-card>
            <div
              class="d-flex justify-space-between"
              :style="{
                'background-color': document.is_archived?'lightgray':''
              }"
              :class="{
                'flex-no-wrap': !$vuetify.breakpoint.mobile,
                'flex-column': $vuetify.breakpoint.mobile,
              }"
            >
              <div>
                <v-card-title class="py-2">
                  {{ document.is_archived?'[ARCHIVÁLT] ':'' }}{{ document.title }}
                </v-card-title>
                <v-card-subtitle class="title font-weight-bold mt-2">
                  Szám: {{ document.serial_number }}
                </v-card-subtitle>
                <v-card-subtitle>
                  Dátum: {{ document.effective_date }}
                </v-card-subtitle>
                <v-card-subtitle>
                  {{ document.issuer.name }}{{(document.regulator.name.endsWith('Közös')?'':'i')}} {{ document.regulator.name.toLowerCase() }}
                </v-card-subtitle>
                <v-card-text v-html="document.content" />
              </div>

              <div
                class="d-flex"
                :class="{
                  'justify-center': $vuetify.breakpoint.mobile
                }"
              >
                <v-card-actions>
                  <v-btn
                    icon
                    x-large
                    link
                    :href="document.file_path"
                    target="_blank"
                  >
                    <v-icon>
                      mdi-file-document-multiple-outline
                    </v-icon>
                  </v-btn>

                  <v-btn icon x-large @click="showDocument(document)">
                    <v-icon>
                      mdi-arrow-right-bold-outline
                    </v-icon>
                  </v-btn>
                </v-card-actions>
              </div>
            </div>
          </v-card>
        </v-col>

        <v-col cols="12">
          <Pagination @handlePageChanged="getPublicDocuments" />
        </v-col>
      </template>
      <template v-else >
        <v-skeleton-loader v-if="loading" type="article, list-item:text, actions" width="100%"></v-skeleton-loader>
        <v-card v-if="!loading" elevation="0" class="mx-auto">
          <v-card-title class="text-h4">
            Nem találhatók dokumentumok!
          </v-card-title>
        </v-card>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import PublicDocumentModal from './Modals/PublicDocumentModal'
import Pagination from '../../components/Table/Pagination/Pagination'
import {
    SET_DOCUMENT,
    SET_FILTERS,
    SET_ITEM,
    SET_SHOW_MODAL
} from "../../utils/constants";
export default {
  name: "PublicDocumentsList",
  components:{
    PublicDocumentModal,
    Pagination
  },
  mounted() {
    this.getPublicDocuments();
  },
  watch: {
    filters() {
      this.getPublicDocuments();
    }
  },
  computed: {
    ...mapGetters("Document", ["documents","loading"]),
    ...mapGetters("Table", ["params", "filters", "orders", "orderValues"])
  },
  methods: {
    ...mapActions("Document", ["getPublicDocuments","getDocumentHistory"]),
    ...mapMutations("Table", [SET_FILTERS]),
    ...mapMutations("Modal", [SET_SHOW_MODAL, SET_ITEM]),
    ...mapMutations("Document", [SET_DOCUMENT]),
    showDocument(doc) {
        this.getDocumentHistory(doc)
    }
  }
};
</script>

<style>
.highlighted {
  background: yellow;
  font-weight: bold;
  font-style: italic;
  color: black;
}
</style>
